import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Input, Select } from 'antd';
import { Switch, FormControlLabel } from '@material-ui/core';
import { Container, Strong } from './CopyModal.styled';
import Modal from '../../../Modal';
import {
  selectedOrganizationSelector,
  organizationListSelector,
  userDetailSelector,
  userPrivilegesSelector,
} from '../../../../redux/selector';
import {
  Content,
  SmallText,
} from '../../../BeeFreeEditor/savedRows/SavedRowsModal.styled';

const { Option } = Select;

const CopyModal = ({
  isCreatingCopy,
  setCopyName,
  copyName,
  createCopy,
  closeCopyModal,
  setNewOrgId,
  newOrgId,
  isDraftCard,
  createSharedTemplateCopy,
}) => {
  const selectedOrg = useSelector(selectedOrganizationSelector);
  const initialOrgList = useSelector(organizationListSelector);
  const user = useSelector(userDetailSelector);
  const { isSA } = useSelector(userPrivilegesSelector);
  const [orgList, setOrgList] = useState(initialOrgList);
  const [shouldCreateSharedTemplate, setShouldCreateSharedTemplate] =
    useState(false);

  const handleCopyNameChange = event => {
    setCopyName(event.target.value);
  };

  const handleShouldCreateSharedTemplateToggleChange = () => {
    setShouldCreateSharedTemplate(!shouldCreateSharedTemplate);
  };

  const handleSearch = value => {
    if (value) {
      const filteredOrgs = initialOrgList.filter(field => {
        return field.organizationName
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      setOrgList(filteredOrgs);
    } else {
      setOrgList(initialOrgList);
    }
  };

  const mainMessage = isDraftCard ? (
    <span>
      Creates a copy of the <strong>design</strong> of the selected draft.{' '}
      {newOrgId && (
        <>
          <strong>Audience</strong> is not copied over.
        </>
      )}
    </span>
  ) : (
    <span>
      Creates a copy of the <Strong>design</Strong> of the selected template.{' '}
      <Strong>Message info</Strong> is not copied over.
    </span>
  );

  const onClick = () => {
    if (shouldCreateSharedTemplate) {
      createSharedTemplateCopy();
    } else {
      createCopy();
    }
  };

  return (
    <Modal
      title="Duplicate Message Design"
      primaryButton={{
        label: 'Save',
        onClick,
        isLoading: isCreatingCopy,
      }}
      onClose={closeCopyModal}
    >
      <Container>
        {mainMessage}
        <Input
          value={copyName}
          onInput={handleCopyNameChange}
          placeholder="Name"
        />
        {user.multiOrgUser && !shouldCreateSharedTemplate && (
          <Select
            defaultValue={selectedOrg.id}
            style={{ width: '100%' }}
            onChange={value => {
              setNewOrgId(value);
            }}
            onSearch={handleSearch}
            showSearch
            filterOption={false}
          >
            {orgList.map(org => (
              <Option key={org.id} value={org.id}>
                {org.organizationName}
              </Option>
            ))}
          </Select>
        )}
        {isSA &&
          !isDraftCard && ( // only allowing super admins to create shared template
            <FormControlLabel
              control={
                <Switch
                  checked={shouldCreateSharedTemplate}
                  onChange={handleShouldCreateSharedTemplateToggleChange}
                  color="primary"
                />
              }
              label={
                <Content>
                  <span>⁂ Creates New Shared Template</span>
                  <SmallText>
                    Creates a new Shared Template available to all
                    organizations.
                  </SmallText>
                </Content>
              }
            />
          )}
      </Container>
    </Modal>
  );
};

export default CopyModal;
